import { createModel } from '@rematch/core';
import { generatePath } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AxiosError, AxiosRequestConfig } from 'axios';

import URL from '../../constants/api-constants';
import { RootModel } from '.';
import createBaseMetaFieldsModel from './utils/createBaseMetaFieldsModel';
import http from '../http/http-common';
import { BaseApi } from '../http/base-api.service';

const apiService = new BaseApi();
const baseMetaFieldsModel = createBaseMetaFieldsModel(URL.CONTRACT_META_FIELDS);

const headers: AxiosRequestConfig['headers'] = apiService.getApiVersionHeader();

export const contract_meta_fields = createModel<RootModel>()({
  ...baseMetaFieldsModel,
  effects: () => ({
    ...baseMetaFieldsModel.effects!(),

    async saveAsClientDefault(id: string) {
      try {
        const path = generatePath(URL.CONTRACT_META_FIELDS_SAVE_AS_CLIENT_DEFAULT, { id });
        await http.patch(path, {}, { headers });
        toast.success('Client default meta fields updated successfully');
      } catch (error: unknown) {
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.message || 'An unexpected error occurred');
        } else if (error instanceof Error) {
          toast.error(error.message);
        } else {
          toast.error('An unexpected error occurred');
        }
        throw error;
      }
    },
  }),
});
